"use client";

import { cn } from "@/lib/utils";
import Image from "next/image";
import { bdlcItems } from "./bdlcData";

interface Item {
  name: string;
  description: string;
  icon: string;
}



const Notification = ({ name, description, icon }: Item) => {
  return (
    <figure
      className={cn(
        "relative mx-auto min-h-fit w-full max-w-full cursor-pointer overflow-hidden  p-4",
        "bg-white shadow"
      )}
    >
      <div className="flex flex-row items-center gap-3">
        <div className="flex items-center justify-center">
          <Image
            src={icon}
            alt={name}
            width={32}
            height={32}
            className="w-16 h-16"
          />
        </div>
        <div className="flex flex-col overflow-hidden">
          <figcaption className="text-base md:text-lg font-medium leading-tight text-gray-900 mb-0">
            {name}
          </figcaption>
          <p className="text-sm font-normal text-gray-600">{description}</p>
        </div>
      </div>
    </figure>
  );
};

export function ItemList({ className }: { className?: string }) {
  return (
    <div
      className={cn(
        "relative flex w-full flex-col gap-4 p-2",
        className
      )}
    >
      {bdlcItems.map((item, idx) => (
        <Notification
          key={idx}
          name={item.title}
          description={item.description}
          icon={item.iconSrc}
        />
      ))}
    </div>
  );
}
